export const KNOWN_MUTATION_SUFFIXES = {
  CREATE_ENDPOINT_MUTATION: 'CREATE_ENDPOINT',
  NOTIFICATION_UPDATE_MUTATION: 'NOTIFICATION_UPDATE',
  SECURITY_UPDATE_MUTATION: 'SECURITY_UPDATE',
  SEND_RESET_EMAIL_MUTATION: 'SEND_RESET_EMAIL',
  SWITCH_CHAINS_MUTATION: 'SWITCH_CHAINS',
}

export const KNOWN_QUERY_SUFFIXES = {
  DAILY_BREAKDOWN_METRICS: 'DAILY_BREAKDOWN_METRICS',
  HOURLY_LATENCY_METRICS: 'HOURLY_LATENCY_METRICS',
  LATEST_FILTERED_DETAILS: 'LATEST_FILTERED_DETAILS',
  LATEST_RELAYS: 'LATEST_RELAYS',
  ONCHAIN_DATA: 'ONCHAIN_DATA',
  PREVIOUS_SUCCESSFUL_METRICS: 'PREVIOUS_SUCCESSFUL_METRICS',
  PREVIOUS_TOTAL_METRICS: 'PREVIOUS_TOTAL_METRICS',
  SESSION_METRICS: 'SESSION_METRICS',
  STAKEABLE_CHAINS: 'STAKEABLE_CHAINS',
  USER_APPS: 'USER_APPS',
  WEEKLY_SUCCESSFUL_METRICS: 'WEEKLY_SUCCESSFUL_METRICS',
  WEEKLY_TOTAL_METRICS: 'WEEKLY_TOTAL_METRICS',
}
